export default __webpack_public_path__ + "static/infra-grid-rectangle-hover-f2e90b17a858bfde5dde9c68be15e098.png";